<template>
  <div class="main fr">
    <div class="p40 left fs fg">
      <div>个人资料</div>

      <div class="p30">
        <div class="fr ac">
          <div>当前头像</div>
          <div class="fr ac cursor" style="margin-left: 46px;position: relative">
            <img
                :src="memberInfo.member_img"
                style="width: 60px;height: 60px;border-radius: 50%"
                alt
            />
            <!--            <img class="ml20" src="/static/imgs/me/modify.png" alt style="width: 30px;height: 25px"/>-->
            <!--            <span class="ml10">修改</span>-->

            <!--            <input type="file" name="file" class="avatar-upload" @change="uploadFile"/>-->
          </div>
        </div>

        <!--                昵称-->
        <div class="fr ac mt50">
          <div>昵称:</div>
          <div class="fr ac" style="margin-left: 46px">
            <el-input style="width: 346px" v-model="memberInfo.member_nick_name"></el-input>
          </div>
        </div>

        <!--                性别-->
        <div class="fr ac mt50">
          <div>性别:</div>
          <div class="fr ac" style="margin-left: 46px">
            <el-radio-group v-model="memberInfo.member_sex">
              <el-radio label="m">男</el-radio>
              <el-radio label="w">女</el-radio>
            </el-radio-group>
          </div>
        </div>

        <!--              电话-->
        <div class="fr ac mt50">
          <div>电话:</div>
          <div class="fr ac" style="margin-left: 46px">
            <el-input style="width: 346px" disabled v-model="memberInfo.member_account"></el-input>
          </div>
        </div>
      </div>

      <div class="fc jc ac" style="margin-top: 159px">
        <!--        <div @click="save" class="btn" style="background-color: #458EF6;color: white">保存</div>-->
        <div
            v-if=" hasPermission(899)"
            @click="role_transfer_show=true"
            class="btn mt30"
            style="background-color: white;color: #458EF6"
        >权限转移
        </div>
      </div>
    </div>
    <div class="right fg" v-if="hasRole([8])">
      <div class="fc ac">
        <img :src="img" alt/>
        <p class="fz14">我的二维码</p>
        <button class="mt20 btn cursor" @click="downloadCanvasIamge">下载到本地</button>
      </div>
    </div>
    <re-dialog title="提示" :visible.sync="role_transfer_show">
      <div class="p20">
        <el-radio-group v-model="transfer_id" style="width: 100%;">
          <el-table
              ref="singleTable"
              :data="workmate_list"
              highlight-current-row
              @current-change="handleCurrentChange"
              style="width: 100%">
            <el-table-column
                align="center"
                width="50">
              <template slot-scope="scope">
                <el-radio :label="scope.row.member_id">&nbsp;</el-radio>
              </template>
            </el-table-column>

            <el-table-column
                align="center"
                label="头像">
              <template slot-scope="scope">
                <el-avatar :size="60" :src="scope.row.member_img">
                  <img src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png"/>
                </el-avatar>
              </template>
            </el-table-column>
            <el-table-column
                align="center"
                property="member_nick_name"
                label="姓名">
            </el-table-column>
            <el-table-column
                align="center"
                property="member_account"
                label="联系电话">
            </el-table-column>
          </el-table>
        </el-radio-group>
      </div>
      <span slot="footer" class="dialog-footer fr jc ac">
        <el-button type="primary" @click="transferAuth">确 定</el-button>
      </span>
    </re-dialog>

  </div>
</template>

<script>
export default {
  data() {
    return {
      memberInfo: this.$store.state.memberInfo,
      //权限转移弹窗
      role_transfer_show: false,
      // 同事列表
      workmate_list: [],

      //    转移角色ID
      transfer_id: "",
      img: this.$store.state.memberInfo.qrcode_img
    };
  },
  mounted() {
    this.getWorkMateList();
  },
  methods: {
    handleCurrentChange(i) {
      this.transfer_id = i.member_id;
    },
    downloadCanvasIamge(selector, name) {
      let image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        let canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;

        let context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        let url = canvas.toDataURL("image/png");

        // 生成一个a元素
        let a = document.createElement("a");
        // 创建一个单击事件
        let event = new MouseEvent("click");

        a.download = name || "pic";
        // 将生成的URL设置为a.href属性
        a.href = url;
        // 触发a的单击事件
        a.dispatchEvent(event);
      };

      image.src = this.img;
    },
    //上传成功
    async uploadFile(e) {
      this.memberInfo.member_img = await this.upload(e.target.files);
    },
    //保存
    save() {
      let param = Object.assign({}, this.memberInfo);
      param.memberRoleBeans = JSON.stringify(param.memberRoleBeans);
      this.post("memberInterfaces/v1.0/updateMemberDetail", param).then(res => {
        this.$message("修改成功");
        this.getMemberDetail();
      });
    },
    //获取用户详情
    getMemberDetail() {
      let param = {};
      this.post("memberInterfaces/v1.0/getMemberDetail", param).then(res => {
        this.memberInfoInit(res.data);
      });
    },
    //    获取同事列表
    getWorkMateList() {
      if (!this.hasRole([10, 11])) return;
      let auth_type = "";
      let relation_id = "";

      if (this.hasMemberType(2)) {
        auth_type = 2;
        relation_id = this.memberInfo.company_id;
      }

      if (this.hasMemberType(3)) {
        auth_type = 3;
        relation_id = this.memberInfo.merchants_id;
      }

      if (this.hasMemberType(4)) {
        auth_type = 4;
        relation_id = -1;
        return;
      }

      let param = {
        auth_type: auth_type,
        relation_id: relation_id
      };
      this.post("memberRoleInterfaces/v1.0/getCompanyWorkmateList", param).then(
          res => {
            this.workmate_list = res.data;
          }
      );
    },
    //    权限转移
    transferAuth() {
      let memberInfo = this.memberInfo;
      let auth_type = "";
      let relation_id = "";
      if (this.hasMemberType(2)) {
        auth_type = 2;
        relation_id = this.memberInfo.company_id;
      }

      if (this.hasMemberType(3)) {
        auth_type = 3;
        relation_id = this.memberInfo.merchants_id;
      }

      if (this.hasMemberType(4)) {
        auth_type = 4;
        relation_id = -1;
      }

      let param = {
        auth_type: auth_type,
        transfer_id: this.transfer_id
      };

      if (!param.auth_type) {
        this.$message("auth_type为空");
        return;
      }
      if (!param.transfer_id) {
        this.$message("transfer_id为空");
        return;
      }

      this.post("memberInterfaces/v1.0/transferMemberRole", param).then(res => {
        this.$message("权限转移成功");

        this.role_transfer_show = false;
        this.getMemberDetail();
      });
    }
  },
  components: {}
};
</script>

<style scoped lang="scss">
.main {
  .left {
    .btn {
      width: 346px;
      height: 44px;
      opacity: 1;
      border: 1px solid rgba(69, 142, 246, 1);
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }

    .member-role {
      width: 78px;
      height: 22px;
      background: rgba(69, 142, 246, 1);
      opacity: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      color: white;
    }

    .avatar-upload {
      position: absolute;
      opacity: 0;
    }
  }

  .right {
    padding-top: 120px;
    border-left: 1px solid #e5e5e5;

    .btn {
      width: 200px;
      height: 44px;
      background: rgba(15, 126, 251, 1);
      color: white;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/page/me/profile/index.vue